module.exports = __webpack_public_path__ + "img/tech_image_17.180858c4.jpg";